// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--3yXSL","bodyContainer":"style-module--bodyContainer--FdSsm"};